import { css } from 'styled-components';

// LA BARRA DI SCORRIMENTO DEI PANNELLI DELLA SCENA.
//
// Quella di sistema è larga il doppio, porta due frecce che nessuno usa e ha un fondo grigio che
// taglia il pannello in due: dentro una colonna larga trecento pixel è una striscia di arredamento
// che ruba spazio al contenuto.
//
// **Si dichiara su CHI SCORRE, non su un antenato.** Scritta sul contenitore del workspace come
// regola discendente non arrivava: `scrollbar-width` e `scrollbar-color` si ereditano, ma
// `::-webkit-scrollbar` è uno pseudo-elemento dell'elemento che scorre — e i due meccanismi si
// escludono a vicenda nei browser recenti, dove basta dichiarare il primo perché il secondo venga
// ignorato. Qui stanno insieme sullo stesso elemento: i browser nuovi usano lo standard, i vecchi
// il pseudo-elemento, e il risultato è lo stesso in tutti e due.
//
// Il bordo del pollice è `transparent` più `background-clip` e non un colore: dichiarato su un
// fondo preciso disegnerebbe un alone sbagliato su ogni superficie diversa da quella. Così nessun
// pannello deve sapere su che fondo poggia.
//
// Non è una regola globale: le altre pagine del backoffice tengono la loro.
export const thinScrollbar = css`
    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.app.borderColor} transparent;

    &::-webkit-scrollbar {
        width: 9px;
        height: 9px;
    }

    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-corner {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.app.borderColor};
        border: 2px solid transparent;
        border-radius: 5px;
        background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: ${(props) => props.theme.app.primary};
        background-clip: padding-box;
    }
`;
